import { useNavigate } from '@remix-run/react'
import { Button } from '~/design-system/primitives'
import { CreditCardOff, LocalMall } from '~/icons'

export default function EmptyCard() {
  const navigate = useNavigate()

  const handleNavigateHome = () => {
    navigate('/')
  }

  return (
    <div className="lg:h-screen w-full p-4 flex justify-center items-center rounded-lg bg-white">
      <div
        className="lg:w-full text-center h-full px-8 flex flex-col justify-center items-center rounded-lg lg:bg-white bg-gray-50
      "
      >
        <CreditCardOff className="fill-gray-40 mb-4 text-[40px]" />
        <p className="text-xl mb-2 font-bold">Sem cartão cadastrado</p>
        <p className="text-base text-center w-full">
          Para cadastrar seu cartão de crédito, finalize uma compra usando o cartão desejado.
        </p>
        <Button
          className="flex items-center mt-6 gap-2"
          color="primary"
          hasIcon={true}
          isOutlined={true}
          onPress={handleNavigateHome}
        >
          <LocalMall className="fill-primary-orange" />
          Continuar Comprando
        </Button>
      </div>
    </div>
  )
}
